import styled from '@emotion/styled';

import { formatNumber } from '../../../utils/utils';

interface TableNumberFormatterProps {
  data?: Record<string, any>;
  dataKey?: string;
  className?: string;
}

const TableNumberFormatter: React.FC<TableNumberFormatterProps> = ({
  data,
  dataKey,
  className,
}) => {
  const label = data && data[dataKey ?? ''];
  return (
    <Container className={className}>
      {formatNumber(Number(label ?? 0))}
    </Container>
  );
};

export default TableNumberFormatter;

const Container = styled.div`
  word-break: break-word;
  width: 100%;
  color: ${({ theme }) => theme.palette.grayTextColor};
`;
